import { authHttp } from '../http'
import * as routes from '../../routes/picking.routes'
import { errorHandler } from '../../../util/error.service'

export async function saveOcorrencia({
  id,
  company_id,
  sigla,
  company_code,
  descricao,
  assoc_guilty_client,
  actived,
}) {
  try {
    const payload = {
      company_id,
      sigla,
      company_code: company_code && company_code.trim() ? company_code : null,
      descricao,
      assoc_guilty_client,
      actived,
    }

    let response
    if (id) {
      response = await authHttp().put(routes.urlPostPutOcorrencias, {
        id,
        ...payload,
      })
    } else {
      response = await authHttp().post(routes.urlPostPutOcorrencias, payload)
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function importOcorrencias(company_ids, ocorrencias) {
  try {
    const response = await authHttp().post(routes.urlPostImportOcorrencias, {
      company_ids,
      ocorrencias,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getOcorrencias(company_id) {
  try {
    const response = await authHttp().get(routes.urlGetOcorrencias(company_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
